const popularRoutes = [
  {
    image: "https://public.readdy.ai/ai/img_res/389ce6d532fc67b8a1ef4e3f089d27e0.jpg",
    badge: "熱門 No.1",
    badgeColor: "bg-orange-500",
    name: "川藏線深度版",
    days: "14–18 天",
    desc: "不走捷徑，沿線深度遊覽，包含色達、亞青寺等神秘地點",
    tags: ["小眾景點", "攝影天堂", "高原挑戰"],
  },
  {
    image: "https://readdy.ai/api/search-image?query=Majestic%20Xinjiang%20Kanas%20Lake%20surrounded%20by%20autumn%20birch%20forest%20and%20snow%20mountains%2C%20mirror-like%20turquoise%20water%20reflection%2C%20misty%20morning%20atmosphere%2C%20stunning%20nature%20landscape%20photography&width=600&height=400&seq=812&orientation=landscape",
    badge: "最多家庭選擇",
    badgeColor: "bg-green-500",
    name: "新疆全景環線",
    days: "12–16 天",
    desc: "喀納斯、獨庫公路、天山天池一網打盡，壯觀震撼",
    tags: ["親子友善", "多元風景", "必打卡"],
  },
  {
    image: "https://readdy.ai/api/search-image?query=European%20mountain%20pass%20road%20through%20Swiss%20Alps%20with%20dramatic%20rocky%20peaks%2C%20glacier%20views%2C%20crystal%20clear%20mountain%20lake%20reflection%2C%20sunny%20summer%20day%2C%20travel%20photography%20with%20vivid%20colors&width=600&height=400&seq=813&orientation=landscape",
    badge: "終極挑戰",
    badgeColor: "bg-zinc-800",
    name: "歐洲三大極限",
    days: "21–28 天",
    desc: "特倫蒂諾、格羅斯格洛克納、斯泰爾維奧，頂級公路三合一",
    tags: ["地獄難度", "超絕風景", "車手必去"],
  },
];

const customizableItems = [
  { icon: "ri-map-2-line", title: "起點 / 終點", desc: "香港出發，可選不同城市結束，機票銜接更靈活" },
  { icon: "ri-calendar-line", title: "行程天數", desc: "3 天短途至 30 天長征，完全根據您的假期安排" },
  { icon: "ri-restaurant-line", title: "餐飲體驗", desc: "地道小館、米芝蓮、高原牧民烤全羊，任君選擇" },
  { icon: "ri-bike-line", title: "加配活動", desc: "徒步、騎馬、熱氣球、星空露營等特色體驗" },
  { icon: "ri-user-heart-line", title: "私人導遊", desc: "本地嚮導、攝影師、翻譯，按需求靈活加配" },
  { icon: "ri-shield-star-line", title: "保障級別", desc: "標準版或頂級全保方案，視乎您的保障需求" },
];

const CustomOptions = () => (
  <section className="py-24 bg-stone-50">
    <div className="w-full px-6 lg:px-12">

      {/* Customizable Items */}
      <div className="text-center mb-14">
        <span className="text-orange-500 text-sm font-semibold tracking-wider uppercase mb-4 block">
          想改什麼就改什麼
        </span>
        <h2 className="text-4xl font-bold text-gray-900 mb-4">
          每個環節，皆可自訂
        </h2>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto">
          沒有固定模版，沒有不能改的部分。以下全部皆可按您喜好調整
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-20">
        {customizableItems.map((item) => (
          <div key={item.title} className="bg-white rounded-2xl p-5 text-center border border-stone-100 hover:border-orange-200 transition-all group">
            <div className="w-12 h-12 bg-orange-50 rounded-xl flex items-center justify-center mx-auto mb-3 group-hover:bg-orange-100 transition-colors">
              <i className={`${item.icon} text-orange-500 text-xl`}></i>
            </div>
            <h4 className="text-gray-900 font-bold text-sm mb-1">{item.title}</h4>
            <p className="text-gray-400 text-xs leading-relaxed">{item.desc}</p>
          </div>
        ))}
      </div>

      {/* Popular Custom Routes */}
      <div className="text-center mb-10">
        <h2 className="text-3xl font-bold text-gray-900 mb-3">
          最熱門自訂路線方向
        </h2>
        <p className="text-gray-600">以下為最多客人選擇的自訂行程方向，可直接作為起點，再按您需求修改</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-7">
        {popularRoutes.map((route) => (
          <div key={route.name} className="group cursor-pointer bg-white rounded-2xl overflow-hidden border border-stone-100 hover:border-orange-200 transition-all hover:-translate-y-1">
            <div className="relative h-52 overflow-hidden">
              <img
                src={route.image}
                alt={route.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute top-4 left-4">
                <span className={`${route.badgeColor} text-white text-xs font-bold px-3 py-1.5 rounded-full`}>
                  {route.badge}
                </span>
              </div>
              <div className="absolute bottom-4 left-4 right-4">
                <h3 className="text-xl font-bold text-white">{route.name}</h3>
                <span className="text-white/70 text-sm">{route.days}</span>
              </div>
            </div>
            <div className="p-5">
              <p className="text-gray-600 text-sm leading-relaxed mb-4">{route.desc}</p>
              <div className="flex flex-wrap gap-2">
                {route.tags.map((tag) => (
                  <span key={tag} className="text-xs text-gray-600 bg-stone-100 px-3 py-1 rounded-full">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

    </div>
  </section>
);

export default CustomOptions;
